<template>
  <div class="class-container">
    <div class="top" v-if="level != 3">
      <form action=".">
        <van-search
          class="search-content"
          v-model="keyWord"
          placeholder="搜索关键词"
          @search="bindSearch"
        />
        <input type="text" style="display: none" />
      </form>
      <div class="nav-content">
        <van-tabs v-model="curTitle" @click="changeTitle" class="tabs-content">
          <van-tab
            :title="item"
            v-for="(item, index) in titleList"
            :key="index"
          >
          </van-tab>
        </van-tabs>
        <span
          class="select-nav iconfont icon-gengduo"
          @click.stop="showPopup"
        ></span>
      </div>
    </div>
    <div class="sort-container" v-if="titleList.length && level != 3">
      <div class="total">共{{ typeList[curTitle].total || 0 }}条</div>
      <div class="sort-content">
        <div class="text">排序：</div>
        <div class="btn-content">
          <div
            class="btn-item"
            :class="{ 'btn-item-active': curSort == index }"
            v-for="(item, index) in sortList"
            :key="index"
            @click.stop="changeSort(index)"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="search-container" v-if="titleList.length && id == 2">
      <div class="search-item">
        <div class="search-time" @click="bindshowPicker(0)">
          <div class="text">营期</div>
          <div class="search-text">
            {{ curCamp === '' ? '' : campList[curCamp].name }}
          </div>
          <span class="iconfont icon-xiala"></span>
          <!--   <span class="iconfont icon-cha" wx:else @click.stop="clearStartTime"></span> -->
        </div>
        <div class="search-time" @click="bindshowPicker(1)">
          <div class="text">可使用渠道</div>
          <div class="search-text">
            {{ curChannel === '' ? '' : channelList[curChannel].name }}
          </div>
          <span class="iconfont icon-xiala"></span>
          <!-- <span class="iconfont icon-cha" @click.stop="clearEndTime"></span> -->
        </div>
      </div>
    </div>
    <!--  -->
    <div class="container-flex1">
      <div v-if="level != 3" style="height: 100%">
        <div
          style="height: 100%; overflow-y: scroll"
          v-for="(item, index) in typeList"
          :key="index"
          v-show="curTitle == index"
        >
          <van-pull-refresh
            v-model="item.refresh"
            success-text="刷新成功"
            @refresh="onRefresh()"
            style="min-height: 100%"
          >
            <van-list
              v-if="item.loaded"
              v-model="item.loading"
              :finished="item.finished"
              finished-text="没有更多了"
              :immediate-check="false"
              @load="loadData(false)"
            >
              <div class="scroll-content">
                <template>
                  <div v-for="(item1, index1) in item.data" :key="index1">
                    <div v-if="id == 'wdsc'" class="item-time">
                      {{ item1.addDay }}
                    </div>
                    <div
                      class="article-list"
                      :class="{ 'article-padding': id == 'wdsc' }"
                    >
                      <div
                        class="article-item"
                        v-for="(item2, index2) in item1.data"
                        :key="index2"
                      >
                        <WordsItem
                          v-if="item2.type == 3"
                          :data="item2"
                          :copy="true"
                        />
                        <VideoItem v-if="item2.type == 2" :data="item2" />

                        <CaseItem v-if="item2.type == 4" :data="item2" />

                        <PictureItem
                          v-if="item2.type == 1 && id == 'wdsc'"
                          :data="item2"
                          :list="item1.data"
                          :index="index1"
                          :index1="index2"
                          @click="imageClick"
                        />
                        <ImageItem
                          v-if="item2.type == 1 && id !== 'wdsc'"
                          :data="item2"
                        />
                      </div>
                    </div>
                  </div>
                </template>
                <!-- <div class="not-data" v-if="!item.data.length && item.loaded">
                  暂无内容
                </div> -->
                <!-- <van-loading
                  class="loading"
                  v-if="item.loading"
                  text-color="#888888"
                  color="#888888"
                  vertical
                  >加载中...</van-loading> -->
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
      <!-- 图库 -->
      <template v-if="level == 3">
        <div class="picture-container">
          <div
            class="class-item"
            v-for="(item, index) in typeList"
            :key="index"
          >
            <div class="item-top" @click.stop="changeOpenStatus(index)">
              <span class="item-title">{{ item.name }}</span>
              <span class="item-num">{{ item.total }}</span>
              <span
                class="iconfont icon-you"
                :class="{ 'iconfont-rotate': curOpen == index }"
              ></span>
            </div>
            <div v-show="index == curOpen">
              <div class="item-list">
                <div
                  class="list-item"
                  v-for="(item1, index1) in item._child"
                  :key="index1"
                >
                  <WordItem v-if="type == 'words'" :data="item1" />
                  <VideoItem v-if="type == 'video'" :data="item1" />
                  <CaseItem v-if="type == 'case'" :data="item1" />
                  <PictureItem v-if="type == 'picture'" :data="item1" />
                  <ImageItem v-if="type == 'image'" :data="item1" />
                </div>
                <div class="not-data" v-if="!item._child.length">暂无更多</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div v-show="isShowPopup" class="popup-container" @click.stop="">
      <div class="popup-content">
        <div
          class="popup-close iconfont icon-cha"
          @click.stop="hidePopup"
        ></div>
        <div class="popup-title">全部分类</div>
        <div class="tag-list">
          <div class="tag-content">
            <div
              class="tag-item"
              v-for="(item, index) in typeList"
              :key="index"
              @click.stop="selectTag(index)"
            >
              <span class="tag-span">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom" round>
      <van-picker
        title="标题"
        show-toolbar
        value-key="name"
        :columns="pickerData"
        @confirm="pickerConfirm"
        @cancel="pickerCancel"
        @change="pickerChange"
      />
    </van-popup>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import WordsItem from '@/views/business-center/components/knowledge/words-item/index'
import CaseItem from '@/views/business-center/components/knowledge/case-item/index'
import ImageItem from '@/views/business-center/components/knowledge/image-item/index'
import PictureItem from '@/views/business-center/components/knowledge/picture-item/index'
import VideoItem from '@/views/business-center/components/knowledge/video-item/index'
import NavpPopup from '@/views/business-center/components/knowledge/nav-popup/index'
export default {
  name: 'fatcamp-second-class',
  components: {
    WordsItem,
    CaseItem,
    ImageItem,
    PictureItem,
    VideoItem,
    NavpPopup
  },
  data() {
    return {
      curOpen: 0, //图库当前展开的是哪个列表
      titleList: [],
      curTitle: 0,
      title: '',
      loaded: false,
      isLoaded: false, //页面是否是刷新页面过后的
      refresh: false, //层级为3时的刷新控制
      finished: false, //层级为3时的结束控制
      loading: false, //层级为3时的加载控制
      id: '',
      type: '', //
      level: '',
      activeName: 0,
      curSort: 0,
      sortList: [
        {
          text: '热度',
          key: 'num'
        },
        {
          text: '时间',
          key: 'id'
        }
      ], //排序列表
      show: false,
      typeList: [],
      dayObject: [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ],
      keyWord: '',
      preKeyWord: '',
      isShowPopup: false, //是否显示popup
      curCamp: '', //当前筛选营期
      curChannel: '', // 当前渠道
      channelList: [], //渠道列表
      campList: [], //所有营期列表
      scrollTopNum: 0, //竖直滚动条位置
      curPicker: '', //当前的picker
      pickerData: [], //picker数据
      showPicker: false
    }
  },
  beforeRouteEnter(to, form, next) {
    if (form.path == '/fatcamp/home' || form.path == '/') {
      to.meta.ifDoFresh = true
    } else {
      to.meta.ifDoFresh = false
    }
    next()
  },
  created() {
    this.getSearchData()
    this.getPro()
  },
  activated() {
    this.getParams(this.$route.query)
    if (!this.isLoaded) {
      this.getTypePage()
    } else {
      if (this.$route.meta.ifDoFresh) {
        this.$route.meta.ifDoFresh = false
        this.initPage()
        //this.resetData();
        this.getTypePage()
      }
    }
    this.isLoaded = true
  },
  methods: {
    resetData() {
      if (this.level != 3) {
        this.typeList[this.curTitle].loading = true
        this.typeList[this.curTitle].finished = false
        this.typeList[this.curTitle].data = []
        this.typeList[this.curTitle].page = 1
        this.typeList[this.curTitle].dateObject = {}
      }
    },
    pickerConfirm(e, index) {
      console.log(e, index)
      if (this.curPicker === 0) {
        this.bindCampChange(index)
      } else if (this.curPicker === 1) {
        this.bindChanelChange(index)
      }
      this.showPicker = false
    },
    pickerCancel() {
      this.showPicker = false
    },
    pickerChange() {},
    bindshowPicker(index) {
      this.curPicker = index
      if (index === 0) {
        this.pickerData = this.campList
      } else if (index === 1) {
        this.pickerData = this.channelList
      }
      this.showPicker = true
    },
    //营期筛选时
    bindCampChange(index) {
      this.curCamp = index
      this.resetData()
      this.loadData(true)
    },
    //渠道筛选时
    bindChanelChange(index) {
      this.curChannel = index
      this.resetData()
      this.loadData(true)
    },
    //获取营期列表
    getPro() {
      this.$http
        .postApp('member/StorageLogin/getQue', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.unshift({
              id: '',
              name: '全部',
              num: 0
            })
            this.campList = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    imageClick(e) {
      console.log(e)
      let index = e.detail.index
      let index1 = e.detail.index1
      let url = 'https://member3.gymcity.com.cn/#/fatcamp/preview-image'
      wx.navigateTo({
        url:
          '/pages/webview/webview?url=' +
          encodeURIComponent(url) +
          '&index=' +
          index +
          '&index1=' +
          index1 +
          '&data=' +
          JSON.stringify(this.typeList[this.curTitle].data)
      })
    },
    changeSort(index) {
      if (index == this.curSort) {
        return
      }
      this.curSort = index
      this.resetData()
      this.loadData(true)
    },
    showPopup() {
      this.isShowPopup = true
    },
    hidePopup() {
      this.isShowPopup = false
    },
    selectTag(index) {
      this.curTitle = index
      if (
        (!this.typeList[this.curTitle].data.length &&
          !this.typeList[this.curTitle].loaded) ||
        this.keyWord != this.typeList[this.curTitle].keyWord
      ) {
        this.resetData()
        this.loadData(true)
      }
      this.hidePopup()
    },
    getParams(options) {
      this.type = (options && options.type) || 'image'
      this.level = (options && +options.level) || ''
      this.id = (options && options.id) || ''
      this.title = (options && decodeURIComponent(options.title || '')) || ''
      document.title = this.title
    },
    // 获取搜索的数据列表
    getSearchData() {
      this.$http
        .getApp('member/StorageLogin/getCaseWay', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.unshift({
              icon: '',
              id: '',
              name: '全部'
            })
            this.channelList = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //获取tab导航数据
    getTypePage() {
      let params = {
        tid: this.id
      }
      this.$http
        .postApp('member/StorageLogin/getTypePage', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.initTabList(res.data)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.loaded = true
        })
    },
    initPage() {
      this.curOpen = 0 //图库当前展开的是哪个列表
      this.titleList = []
      this.curTitle = 0
      this.loaded = false
      this.isLoaded = false //页面是否是刷新页面过后的
      this.refresh = false //层级为3时的刷新控制
      this.finished = false //层级为3时的结束控制
      this.loading = false //层级为3时的加载控制
      this.activeName = 0
      this.curSort = 0
      this.show = false
      this.typeList = []
      this.keyWord = ''
      this.preKeyWord = ''
      this.curCamp = '' //当前筛选营期
      this.curChannel = '' // 当前渠道
      this.scrollTopNum = 0 //竖直滚动条位置
    },
    //初始化tab导航
    initTabList(data) {
      this.typeList = data.map((item) => {
        let total = 0
        if (this.id != 'wdsc') {
          total = this.getChildrenNum(item)
        }
        let obj = {
          data: [],
          page: 1,
          total,
          dateObject: {},
          refresh: false, //是否正在下拉刷新
          loading: false, //是否正在加载中
          finished: false, //是否还有更多数据
          loaded: false,
          keyWord: '' //当前搜索的关键词
        }
        Object.assign(item, obj)
        return item
      })
      let titleList = this.typeList.map((item) => {
        return item.name
      })
      this.titleList = titleList
      this.typeList = this.typeList
      if (this.level != 3) {
        this.resetData()
        this.loadData(true)
      }
    },
    onRefresh() {
      this.resetData()
      this.loadData(true)
    },
    //获取children个数
    getChildrenNum(item) {
      let total = 0
      if (item._child.length) {
        item._child.map((item1) => {
          total = total + this.getChildrenNum(item1)
        })
      } else {
        total = total + item._list.total
      }
      return total
    },
    //加载数据
    loadData(isCover) {
      console.log('加载')
      let active = this.curTitle
      let urlParams = this.id == 'wdsc' ? 'getSaveList' : 'getTypeList'
      this.typeList[active].loading = true
      console.log(
        '加载' +
          '第' +
          (active + 1) +
          '个界面的第' +
          this.typeList[active].page +
          '页'
      )
      let pid = this.campList.length && this.campList[this.curCamp || 0].id
      let way_id =
        this.channelList.length && this.channelList[this.curChannel || 0].id
      let params = {
        tid: this.typeList[active].id,
        page: this.typeList[active].page,
        cpid: pid,
        way_id,
        key_word: this.keyWord,
        sort_type: this.sortList[this.curSort].key
      }
      this.$http
        .postApp('member/StorageLogin/' + urlParams, params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (isCover) {
              this.typeList[active].data = this.filterTime(
                res.data.data,
                active
              )
              this.typeList[active].refresh = false
            } else {
              this.typeList[active].data = this.typeList[active].data.concat(
                this.filterTime(res.data.data, active)
              )
            }
            this.typeList[active].keyWord = this.keyWord
            this.typeList[active].total = res.data.total
            if (res.data.data.length) {
              this.typeList[active].page++
            } else {
              this.typeList[active].finished = true
            }
            this.typeList[active].loading = false
            // this.typeList[active] = this.typeList[active];
          } else {
            this.$toast(res.msg)
          }
          this.typeList[active].loaded = true
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //搜索内容
    bindSearch(e) {
      console.log()
      this.preKeyWord = this.keyWord
      this.typeList.map((item) => {
        item.page = 1
        item.finished = false
        item.loaded = false
      })
      this.resetData()
      this.loadData(true)
    },
    filterTime(data, active) {
      let obj = {}
      data.map((item) => {
        let time = new Date(item.addtime.replace(/-/g, '/'))
        let timeStr =
          time.getFullYear() +
          '年' +
          (time.getMonth() + 1) +
          '月' +
          time.getDate() +
          '日 ' +
          this.dayObject[time.getDay()]
        if (!this.typeList[active].dateObject[timeStr]) {
          obj[timeStr] = {
            addDay: timeStr,
            data: [item]
          }
          this.typeList[active].dateObject[timeStr] = timeStr
        } else {
          obj[timeStr].data.push(item)
        }
      })
      let res = []
      this.typeList[active].dateObject = {}
      for (let i in obj) {
        res.push(obj[i])
      }
      return res
    },
    changeTitle(index) {
      this.curTitle = index
      if (
        (!this.typeList[this.curTitle].data.length &&
          !this.typeList[this.curTitle].loaded) ||
        this.keyWord != this.typeList[this.curTitle].keyWord
      ) {
        this.resetData()
        this.loadData(true)
      }
    },
    //图库的列表展开或者收起时
    changeOpenStatus(index) {
      let curOpen = this.curOpen
      if (this.curOpen == index) {
        curOpen = -1
      } else {
        curOpen = index
      }
      this.curOpen = curOpen
    }
  }
}
</script>
<style lang="scss">
.words-container {
  .van-tabs__nav {
    background-color: transparent;
  }
  .van-search__content {
    background: transparent;
  }
  .van-collapse-item {
    margin: 2.7vw 0vw;
  }
  input {
    background: transparent !important;
  }
  .van-tabs--line .van-tabs__wrap {
    height: 100%;
  }
}
.search-content {
  .van-search__content {
    background-color: transparent;
  }
}
</style>
<style lang="scss" scoped>
.class-container {
  width: 100%;
  height: 100vh;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
}
.top {
  box-sizing: border-box;
  width: 100%;
  top: 0;
  position: sticky;
  z-index: 2;
  padding: 20px 16px 0px;
  background-color: #fff;
}
.container-flex1 {
  width: 100%;
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}
.picture-container {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.top .nav-content {
  height: 40px;
  display: flex;
  align-items: center;
}
.tabs-content {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}
.nav-content .top-nav {
  flex: 1;
  height: 40px;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 5px;
}
.select-nav {
  padding: 5px 10px;
}
.scroll-content {
  width: 100%;
  min-height: 100%;
  padding-bottom: 20px;
}
.article-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.not-data {
  width: 100%;
  margin: 30px 0px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}
.loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-time {
  padding: 0vw 4.3vw;
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 3.2vw;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 2.7vw;
}
.class-item {
  background-color: #fff;
  margin-bottom: 10px;
}
.class-item .item-top {
  height: 50px;
  display: flex;
  align-items: center;
  padding: 15px 16px;
  box-sizing: border-box;
}
.class-item .item-title {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  font-family: PingFangSC-Medium;
  font-size: 15px;
  color: #000;
  font-weight: 600;
}
.class-item .item-num {
  margin-right: 32px;
  font-family: PingFangSC-Medium;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.5);
}
.class-item .item-list {
  padding: 0px 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  transition: all 0.3s ease;
}
.iconfont-rotate {
  transform: rotate(90deg);
}
.item-list .list-item {
  margin-right: 9px;
  margin-bottom: 9px;
}
.item-list .list-item:nth-child(3n) {
  margin-right: 0px;
}
.popup-container {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
}
.popup-content {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 74vw;
  width: 100%;
  box-sizing: border-box;
  background-color: #f9f9f9;
  padding: 5.3vw;
  display: flex;
  flex-direction: column;
}
.popup-content .popup-title {
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 4vw;
  color: #000;
  margin-bottom: 5.3vw;
}
.popup-content .popup-close {
  position: absolute;
  right: 0;
  top: 0;
  padding: 7px;
  font-size: 18px;
}
.tag-list {
  flex: 1;
  flex-shrink: 0;
  overflow-y: scroll;
}
.tag-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}
.tag-list .tag-item {
  box-sizing: border-box;
  white-space: nowrap;
  padding: 0vw 2vw;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 2.5vw;
  margin-bottom: 2.7vw;
  height: 9.6vw;
  line-height: 9.6vw;
  background-color: #ffffff;
  border-radius: 2.7vw;
  font-family: PingFangSC-Regular;
  font-size: 3.5vw;
  color: #000;
  text-align: center;
}
.tag-list .tag-item .tag-span {
  display: inline-block;
  text-align: left;
}
.tag-list .tag-item:nth-child(3n) {
  margin-right: 0vw;
}
.sort-container {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 47px;
}
.sort-container .total {
  text-indent: 10px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #000;
}
.sort-container .sort-content {
  display: flex;
  align-items: center;
}
.sort-container .btn-content {
  display: flex;
  align-items: center;
  width: 85px;
  height: 20px;
  background-color: #f1f1f1;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 10px;
  color: #000000;
}
.sort-container .btn-item {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sort-container .btn-item-active {
  height: 24px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  border: solid 1px #ddd;
}
.sort-container .text {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-right: 7px;
}
.search-container {
  padding: 5px 16px;
}
.search-container .text {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-right: 7px;
}
.search-container .search-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search-container .picker {
  width: 167px;
  height: 40px;
  background: #f7f7f7;
  border-radius: 6px;
  box-sizing: border-box;
  border: 1px solid #f1f1f1;
}
.search-container .search-time {
  width: 167px;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0px 12px;
  box-sizing: border-box;
  overflow: hidden;

  background: #f7f7f7;
  border-radius: 6px;
  border: 1px solid #f1f1f1;
}
.search-text {
  flex: 1;
  line-height: 40px;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
  white-space: nowrap;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
}
.search-content {
  height: 7.5vw;
  background-color: rgb(237, 237, 237);
  border-radius: 2.7vw;
  padding: 0vw 2.9vw;
  display: flex;
  align-items: center;
  input[type='search']::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
  .search-form {
    margin-left: 2.7vw;
    flex: 1;
    height: 100%;
  }
  .search-input {
    width: 100%;
    height: 100%;
    background-color: transparent !important;
  }
  .search-input::placeholder {
    line-height: 7.5vw;
    font-family: PingFangSC-Regular;
    font-size: 3.2vw;
    color: rgba(0, 0, 0, 0.3);
  }
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
